import DialogController from './dialog_controller';

export default class extends DialogController {
  static targets = ['title', 'submitForm', 'message'];

  open({ title, deleteUrl, message }) {
    this.titleTarget.textContent = title;
    this.submitFormTarget.action = deleteUrl;
    this.messageTarget.textContent = message;

    this.element.showModal();
  }
}
